import { ResultPdfData } from 'src/pdf/build-result-pdf-data.ts';

export async function downloadResultPdf(data: ResultPdfData) {
  const [{ pdf }, { ResultDocument }, { registerPdfFonts }] = await Promise.all([
    import('@react-pdf/renderer'),
    import('./result-document'),
    import('./fonts')
  ]);

  registerPdfFonts();

  const blob = await pdf(<ResultDocument data={data} />).toBlob();
  triggerDownload(blob, fileName(data));
}

function fileName(data: ResultPdfData) {
  const slug = slugify(data.lead.company || data.lead.name);
  return ['zeb-customer-centricity-check', slug, data.dateIso]
    .filter(Boolean)
    .join('_')
    .concat('.pdf');
}

function slugify(value: string) {
  const COMBINING_MARKS = /[̀-ͯ]/g;
  return value
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function triggerDownload(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
